import { createContext, useEffect, useState, ReactNode } from 'react';
import { useMsal } from '@azure/msal-react';

const PagePermissionsContext = createContext({});

type PagePermissionsProviderProps = {
    children: ReactNode;  // Explicitly typing the 'children' prop
};

const userGroups = [
    {
        "userGroupId": 1,
        "pageName": "Excluded_Provider_Form",
        "pageGroup": "DHHS Azure NMEP DB EP Form",
        "createdDate": "2023-12-11T00:00:00.000+00:00",
        "modifiedDate": "2023-12-11T00:00:00.000+00:00",
        "createdBy": "ADMIN",
        "modifiedBy": "ADMIN"
    },
    {
        "userGroupId": 2,
        "pageName": "APM_Form",
        "pageGroup": "DHHS AZURE APM DB BP SF",
        // "createdDate": "2023-12-11T00:00:00.000+00:00",
        "modifiedDate": "2023-12-11T00:00:00.000+00:00",
        "createdBy": "ADMIN",
        "modifiedBy": "ADMIN"
    }
]

export const PagePermissionsProvider = ({ children }: PagePermissionsProviderProps) => {
    const [pagePermissions, setPagePermissions] = useState({});
    const { instance, accounts } = useMsal();

    useEffect(() => {
        const fetchGroups = async () => {
            const account = accounts[0];
            const tokenRequest = {
                scopes: ['User.Read', 'Group.Read.All'],
                account: account,
            };

            try {
                let accessToken = sessionStorage.getItem('msalToken');
                if (!accessToken) {
                    const response = await instance.acquireTokenSilent(tokenRequest);
                    accessToken = response.accessToken;
                    sessionStorage.setItem('msalToken', accessToken);
                }

                const fetchMemberOf = async (url: string | URL | Request) => {
                    const response = await fetch(url, {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    });
                    return response.json();
                };

                const memberOfUrl = 'https://graph.microsoft.com/v1.0/me/memberOf';
                let graphResponse = await fetchMemberOf(memberOfUrl);
                let graphGroup = graphResponse.value;

                while (graphResponse["@odata.nextLink"]) {
                    try {
                        graphResponse = await fetchMemberOf(graphResponse["@odata.nextLink"]);
                        graphGroup = graphGroup.concat(graphResponse.value);
                    } catch (error) {
                        console.error('Failed to fetch additional data:', error);
                        break; // Exit the loop if there's an error
                    }
                }

                graphGroup = graphGroup.filter((group: undefined) => group !== undefined);
                const graphGroupsDisplayNames = graphGroup.map((group: {
                    displayName: string;
                }) => group.displayName.toLowerCase());

                const permissions: { [key: string]: boolean } = {};
                userGroups.forEach((group: { pageName: string | number; pageGroup: string; }) => {
                    permissions[group.pageName] = graphGroupsDisplayNames.indexOf(group.pageGroup.toLowerCase()) > -1;
                });

                sessionStorage.setItem('internal_token', JSON.stringify(permissions));
            } catch (e) {
                console.error('Error fetching groups:', e);
            }
        };

        if (Array.isArray(accounts) && accounts.length > 0) {
            fetchGroups();
        }
    }, [accounts, instance]);

    return (
        <PagePermissionsContext.Provider value={pagePermissions}>
            {children}
        </PagePermissionsContext.Provider>
    );
};

export default PagePermissionsContext;
